import { render } from "./ButtonIcon.vue?vue&type=template&id=3b499a56"
import script from "./ButtonIcon.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ButtonIcon.vue?vue&type=script&charset=utf-8&lang=js"

import "./ButtonIcon.vue?vue&type=style&index=0&id=3b499a56&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__